// removed by extract-text-webpack-plugin
module.exports = {"container":"styles_container__1H3os"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/HomePage/styles.module.css
// module id = 98
// module chunks = 0